import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/pages/MainPage'
import AppLogin from '@/pages/AppLogin'
import AppSignup from '@/pages/AppSignup'
import Analyzer from '@/pages/analyzer/Analyzer'
import JobPage from '@/pages/analyzer/JobPage'
import Review from '@/pages/Review'

import Admin from '@/pages/admin/Admin'
import Overview from '@/pages/admin/Overview'
import Dashboard from '@/pages/admin/Dashboard'
import ManageUsers from '@/pages/admin/ManageUsers'
import Settings from '@/pages/admin/Settings'
import Downloads from '@/pages/admin/Downloads'
import LiveStats from '@/pages/admin/LiveStats'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'AppLogin',
      component: AppLogin
    },
    {
      path: '/signup',
      name: 'AppSignup',
      component: AppSignup
    },
    {
      path: '/main',
      name: 'MainPage',
      component: MainPage
    },
    {
      path: '/analyzer', // Gotta keep the kennemer tradition
      name: 'Analyzer',
      component: Analyzer,

      // Child routes
      children: [
        {
          path: 'jobpage',
          name: 'JobPage',
          component: JobPage
        }
      ]
    },
    {
      path: '/review',
      name: 'Review',
      component: Review
    },
    {
      path: '/admin',
      name: 'Admin',

      // Parent routes still has a component
      component: Admin,

      // Child routes
      children: [
        {
          path: 'overview',
          name: 'Overview',
          component: Overview
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'livestats',
          name: 'LiveStats',
          component: LiveStats
        },
        {
          path: 'manageusers',
          name: 'ManageUsers',
          component: ManageUsers
        },
        {
          path: 'settings',
          name: 'Settings',
          component: Settings
        },
        {
          path: 'downloads',
          name: 'Downloads',
          component: Downloads
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js